import axios from "axios";
import { BACKEND_URL } from "../constants/Constant";

const API_BASE_URL = `${BACKEND_URL}/user-promotional-messages`;

export const fetchPromotionalMessages = async (userId) => {
  try {
    const response = await axios.get(`${API_BASE_URL}/${userId}`);
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || "Failed to fetch custom messages");
  }
};

export const updatePromotionalMessages = async (userId, messages) => {
  try {
    const response = await axios.post(`${API_BASE_URL}/${userId}`, messages);
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || "Failed to update custom messages");
  }
};